import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCaretDown = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	transform: "matrix(1,0,0,-1,0,0)",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_42647_653)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M19.5066 15.0012L12.0039 7.50386L4.50659 15.0065",
			stroke: "#4D4D4D",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_42647_653",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white",
			transform: "matrix(1 -0.000352663 -0.000352663 -1 0.00854492 24.0085)"
		})
	}) })]
});
export default SvgCaretDown;
